import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import DeliveryStartCheck from './components/DeliveryStartCheck';
import DeliveryStartAdmin from './components/DeliveryStartAdmin';
import DeliveryDashboard from './components/DeliveryDashboard';
import AdminDashboard from './components/AdminDashboard';
import DeliveryChart from './components/DeliveryChart';
import ApartmentManager from './components/ApartmentManager';
import ChartBuilder from './components/ChartBuilder';
import ProgramConfigManager from './components/ProgramConfigManager';
import KlsAdHocUpload from './components/KlsAdHocUpload';

function App() {
  useEffect(() => {
    // 앱 시작 시 버전 체크
    const checkVersion = async () => {
      try {
        const hostname = window.location.hostname;
        const apiBase = hostname === 'localhost' || hostname === '127.0.0.1'
          ? 'http://localhost:8000'
          : window.location.protocol === 'https:'
            ? window.location.origin
            : `http://${hostname}:8000`;

        const response = await fetch(`${apiBase}/api/version`);
        if (response.ok) {
          const data = await response.json();
          const serverVersion = data.app_version;
          const localVersion = localStorage.getItem('app_version') || '1.0.0';

          // 서버 버전이 로컬과 다르거나, force_refresh가 true면 새로고침
          if (serverVersion !== localVersion || data.force_refresh) {
            console.log(`버전 업데이트: ${localVersion} → ${serverVersion}`);
            localStorage.setItem('app_version', serverVersion);
            
            // 1초 후 새로고침 (현재 페이지 저장 완료 대기)
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            // 버전 동일 - localStorage에 저장
            localStorage.setItem('app_version', serverVersion);
          }
        }
      } catch (err) {
        console.error('버전 체크 실패:', err);
      }
    };

    // 최초 실행 시에만 체크 (무한 새로고침 방지)
    const hasChecked = sessionStorage.getItem('version_checked');
    if (!hasChecked) {
      sessionStorage.setItem('version_checked', 'true');
      checkVersion();
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/start-check" element={<DeliveryStartCheck />} />
          <Route path="/delivery-start-admin" element={<DeliveryStartAdmin />} />
          <Route path="/dashboard" element={<DeliveryDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/apartments" element={<ApartmentManager />} />
          <Route path="/admin/chart-builder" element={<ChartBuilder />} />
          <Route path="/admin/kls-ad-hoc" element={<KlsAdHocUpload />} />
          <Route path="/admin/program-config" element={<ProgramConfigManager />} />
          <Route path="/chart/:apartmentName/:deliveryDate" element={<DeliveryChart />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    </div>
    </Router>
  );
}

export default App;
